import { render } from "./App.vue?vue&type=template&id=a26ec58c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a26ec58c&lang=css"
script.render = render

export default script